module.exports = __webpack_public_path__ + "img/Coupe_Front_Side_Right_Transparent.7ec3033c.svg";